import { GraphQLClient } from 'graphql-request';
import { gqlEndpoint } from '@frontend/api-payments';
import { getJTI } from '@frontend/auth-helpers';
import appConfig from '@frontend/env';
import { useAppScopeStore } from '@frontend/scope';

export const usePaymentsGraphqlClient = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const jti = getJTI();

  const graphqlEndpoint = `${appConfig.BACKEND_API}${gqlEndpoint}`;

  const client = new GraphQLClient(graphqlEndpoint, {
    headers: {
      authorization: `Bearer ${jti}`,
      'Location-Id': selectedLocationIds[0] ?? '',
    },
  });

  return { client };
};
